/* globals wc_bookings_admin_js_params */
/**
 * This file has logic to handle lazy loading store availability rules.
 * Location of availability rules listing page: "Bookings -> Settings -> Store Availability".
 *
 * @since 1.15.69
 */
import { __ } from '@wordpress/i18n';

document.addEventListener( "DOMContentLoaded", function () {
	const form = document.getElementById( 'bookings_settings' );
	const lazyLoadAvailabilityRuleshiddenField = form ? form.querySelector( '[name="can-lazy-load-availability-rules"]' ) : null;
	const canLazyLoadAvailabilityRules = lazyLoadAvailabilityRuleshiddenField ? parseInt( lazyLoadAvailabilityRuleshiddenField.value ) : 0;

	if ( !canLazyLoadAvailabilityRules ) {
		return;
	}

	// Data about store availability rule types.
	const availability_rule_types = {
		current_list_type: (
			new URLSearchParams( window.location.search )
		).get( 'show' ),
		GOOGLE_EVENT: 'google-events',
		AVAILABILITY_RULES: 'availability-rules',
	}

	const availability_rule = {
		// Data related to remaining (lazy loaded) store availability rules.
		remaining_availability_rules: {
			button: null,
			can_fetch: true,
			next_request_data: {},
			availability_rules_html: ''
		},

		/**
		 * Bootstrap process.
		 *
		 * @since 1.15.69
		 */
		init_lazy_load: () => {
			// Add lazy load feature only on Google events rules list page.
			if ( availability_rule_types.GOOGLE_EVENT !== availability_rule_types.current_list_type ) {
				return;
			}

			const data = {
				per_page: parseInt( form.querySelector( '[name="availability-rules-per-page"]' ).value ),
				step: 1,
				nonce: form.querySelector( '[name="lazy_load_availability_rules_nonce"]' ).value,
				show: availability_rule_types.current_list_type
			};

			availability_rule.register_lazy_load_button();

			// Disable load more button till first batch of availability rules ready to render.
			availability_rule.remaining_availability_rules.button.disabled = true;
			availability_rule.fetch( data );
		},

		/**
		 * Should insert availability rules html to table.
		 *
		 * @since 1.15.69
		 * @param {string} html
		 */
		insert_html: ( html ) => {
			const availability_rows = document.getElementById( 'availability_rows' );

			availability_rows.insertAdjacentHTML( 'beforeend', html );
			jQuery( 'body' ).trigger( 'row_added', availability_rows.querySelector('tr:last-child') );
		},

		/**
		 * Should add lazy load button.
		 *
		 * @since 1.15.69
		 */
		register_lazy_load_button: () => {
			const submit_button_container = form.querySelector( 'p.submit' );
			const button_title = __( 'Load more Google Calendar event rules', 'woocommerce-bookings' );

			// Add load more button.
			submit_button_container.insertAdjacentHTML(
				'beforeend',
				`<button class="button-secondary lazy-load-button" style="margin-left: 5px">${button_title}</button>`
			);

			// Cache button element for future use.
			availability_rule.remaining_availability_rules.button = submit_button_container
				.querySelector( '.lazy-load-button' );

			availability_rule.remaining_availability_rules.button.addEventListener( 'click', ( event ) => {
				const {
					button,
					can_fetch,
					next_request_data,
					availability_rules_html
				} = availability_rule.remaining_availability_rules;

				button.disabled = true;
				button.textContent = __( 'Loading...', 'woocommerce-bookings' );

				// Add availability HTML to dom.
				// Trigger event which attach/perform necessary actions on new table rows.
				window.setTimeout( () => {
					availability_rule.insert_html( availability_rules_html );
				}, 5 );

				// Fetch next batch of availibility rules.
				if ( can_fetch ) {
					window.setTimeout(
						() => availability_rule.fetch( next_request_data ),
						10
					)
				}

				event.preventDefault();
			} );
		},

		/**
		 * Should fetch availability rules html.
		 *
		 * @since 1.15.69
		 * @param {object} data
		 */
		fetch: ( data = null ) => {
			const request = {method: 'POST'}
			const form_data = new FormData();

			// Prepare quest data.
			data.action = 'wc_bookings_lazy_load_availability_rules';
			for ( const property in data ) {
				form_data.append( property, data[property] );
			}
			request.body = form_data;

			fetch( `${wc_bookings_admin_js_params.ajax_url}`, request )
				.then( response => response.json() )
				.then( response => {
					if ( response.success ) {
						// Remove "Load more availability rules" button if all availability rules loaded.
						const {button} = availability_rule.remaining_availability_rules;
						if ( !response.data.lazy_load_availability_rules ) {
							availability_rule.insert_html( response.data.html );
							button.remove();
							return;
						}

						// Increment step.
						++ data.step;

						availability_rule.remaining_availability_rules.availability_rules_html = response.data.html;
						availability_rule.remaining_availability_rules.can_fetch = response.data.lazy_load_availability_rules;
						availability_rule.remaining_availability_rules.next_request_data = data;

						// Activate load more button to allow fetch next batch of availability rules.
						button.disabled = false;
						button.textContent = __( 'Load more Google Calendar event rules', 'woocommerce-bookings' );
					}
				} );
		}
	};

	availability_rule.init_lazy_load();
} );
